import { toAspNetTrueFalse } from "./Utils";
import { PreFilledQuoteModel } from "../interfaces/PreFilledQuoteModel";
import {
    autoDriverLicenseStatusToValueString,
    genderTypeToValueString,
    residenceTypeToValueString,
    creditTypeToValueString,
    insuredSinceLengthToValueString,
    homePropertyTypeToValueString
} from "../common/Enums";
import { WizardStep } from "./WizardStep";

export function mapPreFilledQuoteModelToFormValues(preFilledQuoteModel: PreFilledQuoteModel): void {

    // Primary Vehicle
    (document.getElementById("PrimaryVehicle_Year") as HTMLInputElement).value = preFilledQuoteModel.PrimaryVehicleYear;
    (document.getElementById("PrimaryVehicle_Make") as HTMLInputElement).value = preFilledQuoteModel.PrimaryVehicleMake;
    (document.getElementById("PrimaryVehicle_Model") as HTMLInputElement).value = preFilledQuoteModel.PrimaryVehicleModel;

    // Additional Vehicles
    (document.getElementById("AdditionalVehicles_0__Year") as HTMLInputElement).value = preFilledQuoteModel.AdditionalVehicleYear;
    (document.getElementById("AdditionalVehicles_0__Make") as HTMLInputElement).value = preFilledQuoteModel.AdditionalVehicleMake;
    (document.getElementById("AdditionalVehicles_0__Model") as HTMLInputElement).value = preFilledQuoteModel.AdditionalVehicleModel;

    if (preFilledQuoteModel.AdditionalVehicleYear && preFilledQuoteModel.AdditionalVehicleMake && preFilledQuoteModel.AdditionalVehicleModel) {
        (document.getElementById("NumAdditionalVehicles") as HTMLInputElement).value = "1";
    }

    // Primary Driver
    if (preFilledQuoteModel.LicenseStatus != null) {
        (document.getElementById("PrimaryDriver_LicenseStatus") as HTMLInputElement).value = autoDriverLicenseStatusToValueString(preFilledQuoteModel.LicenseStatus);
    }
    if (preFilledQuoteModel.FilingRequired != null) {
        (document.getElementById("PrimaryDriver_FilingRequired") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.FilingRequired);
    }
    if (preFilledQuoteModel.Gender != null) {
        (document.getElementById("PrimaryDriver_Gender") as HTMLInputElement).value = genderTypeToValueString(preFilledQuoteModel.Gender);
    }
    if (preFilledQuoteModel.Married != null) {
        (document.getElementById("PrimaryDriver_Married") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.Married);
    }

    (document.getElementById("PrimaryDriver_BirthDate") as HTMLInputElement).value = preFilledQuoteModel.BirthDate;

    // Applicant Info
    if (preFilledQuoteModel.CurrentResidence != null) {
        (document.getElementById("ApplicantInfo_CurrentResidence") as HTMLInputElement).value = residenceTypeToValueString(preFilledQuoteModel.CurrentResidence);
    }
    if (preFilledQuoteModel.CreditRating != null) {
        (document.getElementById("ApplicantInfo_CreditRating") as HTMLInputElement).value = creditTypeToValueString(preFilledQuoteModel.CreditRating);
    }
    if (preFilledQuoteModel.IsMilitary != null) {
        (document.getElementById("ApplicantInfo_IsMilitary") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.IsMilitary);
    }

    // Current Insurance
    if (preFilledQuoteModel.CurrentlyInsured != null) {
        (document.getElementById("Insurance_CurrentInsurance_CurrentlyInsured") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.CurrentlyInsured);
    }
    if (preFilledQuoteModel.InsuredSince != null) {
        (document.getElementById("Insurance_CurrentInsurance_InsuredSince") as HTMLInputElement).value = insuredSinceLengthToValueString(preFilledQuoteModel.InsuredSince);
    }
    
    (document.getElementById("Insurance_CurrentInsurance_InsuranceCarrier") as HTMLInputElement).value = preFilledQuoteModel.InsuranceCarrier;

    // Home Add-on
    if (preFilledQuoteModel.Bundle != null) {
        (document.getElementById("HomeAddon_Bundle") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.Bundle);
    }
    if (preFilledQuoteModel.PropertyType != null) {
        (document.getElementById("HomeAddon_PropertyType") as HTMLInputElement).value = homePropertyTypeToValueString(preFilledQuoteModel.PropertyType);
    }
    if (preFilledQuoteModel.AnyClaims != null) {
        (document.getElementById("HomeAddon_AnyClaims") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.AnyClaims);
    }
    if (preFilledQuoteModel.InterestedInFloodInsurance != null) {
        (document.getElementById("HomeAddon_InterestedInFloodInsurance") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.InterestedInFloodInsurance);
    }
    
    (document.getElementById("HomeAddon_YearBuilt") as HTMLInputElement).value = preFilledQuoteModel.YearBuilt;

    if (preFilledQuoteModel.HomeMortgageRefinanceQuoteInterest != null) {
        (document.getElementById("HomeAddon_HomeMortgageRefinanceQuoteInterest") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.HomeMortgageRefinanceQuoteInterest);
    }

    // Incidents
    if (preFilledQuoteModel.AtFaultAccidentInThePastThreeYears != null) {
        (document.getElementById("AtFaultAccidentInThePastThreeYears") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.AtFaultAccidentInThePastThreeYears);
    }
    if (preFilledQuoteModel.TwoOrMoreTicketsInThePastThreeYears != null) {
        (document.getElementById("TwoOrMoreTicketsInThePastThreeYears") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.TwoOrMoreTicketsInThePastThreeYears);
    }
    if (preFilledQuoteModel.DuiConvictionInThePastThreeYears != null) {
        (document.getElementById("DuiConvictionInThePastThreeYears") as HTMLInputElement).value = toAspNetTrueFalse(preFilledQuoteModel.DuiConvictionInThePastThreeYears);
    }

    // Contact Info
    (document.getElementById("ContactInfo_FirstName") as HTMLInputElement).value = preFilledQuoteModel.FirstName;
    (document.getElementById("ContactInfo_LastName") as HTMLInputElement).value = preFilledQuoteModel.LastName;
    (document.getElementById("ContactInfo_Email") as HTMLInputElement).value = preFilledQuoteModel.Email;
    (document.getElementById("ContactInfo_Address") as HTMLInputElement).value = preFilledQuoteModel.Address;
    (document.getElementById("ContactInfo_Address2") as HTMLInputElement).value = preFilledQuoteModel.Address2;

    if (preFilledQuoteModel.ZipCode != null) {
        (document.getElementById("ContactInfo_ZipCode") as HTMLInputElement).value = preFilledQuoteModel.ZipCode.toString();
    }

    (document.getElementById("ContactInfo_PhoneDay") as HTMLInputElement).value = preFilledQuoteModel.Phone;
}

export function getResumeStepFromPreFilledValues(preFilledQuoteModel: PreFilledQuoteModel): WizardStep {

    // Primary Vehicle
    if (preFilledQuoteModel.PrimaryVehicleYear === null || preFilledQuoteModel.PrimaryVehicleYear === "") return WizardStep.PRIMARY_VEHICLE_YEAR;
    if (preFilledQuoteModel.PrimaryVehicleMake === null || preFilledQuoteModel.PrimaryVehicleMake === "") return WizardStep.PRIMARY_VEHICLE_YEAR;
    if (preFilledQuoteModel.PrimaryVehicleModel === null || preFilledQuoteModel.PrimaryVehicleModel === "") return WizardStep.PRIMARY_VEHICLE_YEAR;

    // Current Insurance
    if (preFilledQuoteModel.CurrentlyInsured === null) return WizardStep.INSURANCE_CARRIER;
    if (preFilledQuoteModel.CurrentlyInsured && preFilledQuoteModel.InsuranceCarrier === null) return WizardStep.INSURANCE_CARRIER;
    if (preFilledQuoteModel.CurrentlyInsured && preFilledQuoteModel.InsuredSince === null) return WizardStep.INSURED_SINCE;

    if (preFilledQuoteModel.Gender === null) return WizardStep.GENDER;
    if (preFilledQuoteModel.CreditRating === null) return WizardStep.CREDIT_HISTORY;
    if (preFilledQuoteModel.LicenseStatus === null) return WizardStep.LICENSE_STATUS;

    // Incidents
    if (preFilledQuoteModel.AtFaultAccidentInThePastThreeYears === null ||
        preFilledQuoteModel.TwoOrMoreTicketsInThePastThreeYears === null ||
        preFilledQuoteModel.DuiConvictionInThePastThreeYears === null ||
        preFilledQuoteModel.FilingRequired === null) WizardStep.INCIDENTS;

    if (preFilledQuoteModel.Married === null) return WizardStep.MARITAL_STATUS;
    if (preFilledQuoteModel.IsMilitary === null) return WizardStep.IS_MILITARY;
    if (preFilledQuoteModel.CurrentResidence === null) return WizardStep.HOMEOWNER;

    // Home Add-on
    if (preFilledQuoteModel.Bundle !== null && preFilledQuoteModel.Bundle) {
        if (preFilledQuoteModel.PropertyType === null) return WizardStep.HOME_ADDON_PROPERTY_TYPE;
        if (preFilledQuoteModel.AnyClaims === null) return WizardStep.HOME_ADDON_ANY_CLAIMS;
        if (preFilledQuoteModel.InterestedInFloodInsurance === null) return WizardStep.HOME_ADDON_INTERESTED_IN_FLOOD_INSURANCE;
        if (preFilledQuoteModel.YearBuilt === null) return WizardStep.HOME_ADDON_YEAR_BUILT;
    }

    if (preFilledQuoteModel.BirthDate === null || preFilledQuoteModel.BirthDate === "") return WizardStep.BIRTH_YEAR;

    // Contact Info
    if (preFilledQuoteModel.FirstName === null || preFilledQuoteModel.FirstName === "" ||
        preFilledQuoteModel.LastName === null || preFilledQuoteModel.LastName === "" ||
        preFilledQuoteModel.Email === null || preFilledQuoteModel.Email === "") return WizardStep.CONTACT_INFO_NAME;

    if (preFilledQuoteModel.Address === null || preFilledQuoteModel.Address === "" ||
        preFilledQuoteModel.ZipCode === null ||
        preFilledQuoteModel.Phone === null || preFilledQuoteModel.Phone === "") return WizardStep.CONTACT_INFO_ADDRESS;

    return WizardStep.PRE_FILLED_QUOTE; // This is the start of the quote form
}